module.exports = __webpack_public_path__ + "static/media/download.eeed9eb6.png";